// Sentry init — no-op unless VITE_SENTRY_DSN is set (prod builds only).
// Privacy: no session replay, no PII; auth lives in httpOnly cookies so it
// never reaches JS, but we still drop obvious sensitive URL params.
import * as Sentry from '@sentry/react';

const SENSITIVE_PARAMS = ['token', 'access_token', 'state'];

function scrubUrl(url: string): string {
  try {
    const u = new URL(url, window.location.origin);
    for (const p of SENSITIVE_PARAMS) if (u.searchParams.has(p)) u.searchParams.set(p, '[Filtered]');
    // Access-grant links embed the token in the path: /trust/:slug/access/:token
    u.pathname = u.pathname.replace(/(\/access\/)[^/]+/, '$1[Filtered]');
    return u.toString();
  } catch {
    return url;
  }
}

export function initSentry(): boolean {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return false;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: `condor-portal@${__APP_VERSION__}`,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    beforeSend(event) {
      if (event.request?.url) event.request.url = scrubUrl(event.request.url);
      return event;
    },
  });
  return true;
}

export { scrubUrl };
